










import Vue from 'vue';

export default Vue.extend({
	name: 'ScreenLoader',
	props: {
		vuex: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		isLoading(): boolean {
			return this.loading
				|| (this.vuex && this.$store.state.isLoading);
		},
	},
});
